import React from 'react';
import PageHeader from '../components/common/PageHeader';
import PageMeta from '../components/common/PageMeta';
import FaqTwo from '../components/faqs/FaqTwo';
import FooterOne from '../layout/Footer/FooterOne';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import Footer from "../components/Home/Footer";

const Faq = () => {
  return (
    <Layout>
      <PageMeta title='Sunlex' />
      <Navbar />
      <PageHeader
        title='Frequently Asked Questions'
        desc='Find answers to the most common questions about our platform, services, and features. This section is designed to help you quickly resolve issues and better understand how our solution works.
If you can’t find what you’re looking for, feel free to contact our support team.'
      />
      <FaqTwo />
      <Footer />
    </Layout>
  );
};

export default Faq;
